import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/alerts/no-data-alert/")({
  staticData: {
    title: "fleets.alerts.noDataAlert",
  },
  loader: ({ params }) => {
    throw redirect({
      to: "/sources/fleets/$id/alerts/no-data-alert/trigger",
      params,
      replace: true,
    });
  },
});
